/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, observable } from 'mobx';
import { ProgressTrackerStore } from 'src/core/stores/ProgressTrackerStore';
import { BaseStoreHouse } from 'src/luis/types/stores/core/BaseStoreHouse';

/**
 * A factory function for create a base store house that
 * is to be composed by all store houses in the system.
 */
export const createBaseStoreHouse = (): BaseStoreHouse => {
    const baseStoreHouse: BaseStoreHouse = {
        isLoaded: false,
        isLoading: false,
        isChunking: false,
        tracker: new ProgressTrackerStore(),

        /**
         * Sets the chunking request flag to the value
         * given.
         *
         * @param isChunking The value to set.
         */
        setIsChunking(isChunking: boolean): void {
            this.isChunking = isChunking;
        },
        /**
         * Sets the `isLoaded` flag with the given value.
         *
         * @param isLoaded The flag value. to set.
         */
        setIsLoaded(isLoaded: boolean): void {
            this.isLoaded = isLoaded;
        },

        /**
         * Sets the `isLoading` flag with the given value.
         *
         * @param isLoading The flag value to set.
         */
        setIsLoading(isLoading: boolean): void {
            this.isLoading = isLoading;
        }
    };

    return observable<BaseStoreHouse>(
        baseStoreHouse,
        {
            isLoaded: observable,
            isLoading: observable,
            isChunking: observable,
            setIsChunking: action,
            setIsLoaded: action,
            setIsLoading: action
        },
        { deep: false }
    );
};
